export default __webpack_public_path__ + "static/Lumberjack-8871b13270eb494299479f1e036bdc74.png";